import { ref, watchEffect } from 'vue'

export function $get(object, path, def) {
    try {
        if (typeof path === 'number') {
            path = path.toString()
        }

        return path.split('.').reduce(function (obj, property) {
            if (property === '') {
                return obj
            }

            if (typeof obj[property] === 'undefined') {
                if (typeof def !== 'undefined') {
                    return def
                }
                return undefined
            }

            return obj[property]
        }, object)
    } catch (err) {
        return typeof def !== 'undefined' ? def : undefined
    }
}

export function $set(object, path, value) {
    let namespace = path.split('.')

    const key = namespace.pop()

    object = $get(object, namespace.join('.'))

    return (object[key] = value)
}

export function except(obj, keys) {
    const newObj = obj

    wrapArray(keys).forEach((key) => delete newObj[key])

    return newObj
}

export function empty(value) {
    return typeof value === 'undefined' || value === null
}

export function mapWithKeys(array, callback) {
    let obj = {}

    array.forEach((item) => {
        Object.assign(obj, callback(item))
    })

    return obj
}

export function only(obj, keys) {
    const newObj = {}

    wrapArray(keys).forEach((key) => (newObj[key] = $get(obj, key)))

    return newObj
}

export function optional(test, callback) {
    return empty(test) ? value(callback) : test
}

export function pipe(value, callback) {
    return callback(value)
}

export function selfResettingValue(resetAfterMs) {
    const value = ref(null)

    watchEffect(() => {
        if (value.value !== null) {
            const valueWhenTimerQueued = value.value

            setTimeout(() => {
                if (value.value === valueWhenTimerQueued) {
                    value.value = null
                }
            }, resetAfterMs)
        }
    })

    return value
}

export function tap(value, callback) {
    callback(value)

    return value
}

export function value(value) {
    return typeof value === 'function' ? value() : value
}

export function when(value, callback) {
    return !value || empty(value) ? null : callback(value)
}

export function unless(value, callback) {
    return !value || empty(value) ? callback(value) : null
}

export function wrapArray(value) {
    return empty(value) ? [] : Array.isArray(value) ? value : [value]
}
